module.exports = __webpack_public_path__ + "static/media/cross-icon-red.b527adbf.png";